import { createTranslator, useI18n, type MessageKey, type Vars } from '@vlm/i18n';
import { usePrefs } from '../lib/prefs';
import { ar } from './ar';
import { en, type AdminMessages } from './en';

export type { AdminMessages };
export type Key = MessageKey<AdminMessages>;

/** One stable object: I18nProvider memoises on it. */
export const messages = { en, ar };

/** `const { t, fmt, lang, dir } = useT()` — keys are checked against en.ts. */
export const useT = () => useI18n<AdminMessages>();

export type T = ReturnType<typeof useT>['t'];

/** t() outside React (the session layer's toasts), in the language on screen. */
export function translate(key: Key, vars?: Vars): string {
  return createTranslator(usePrefs.getState().lang, messages)(key, vars);
}
